<template lang="html">
  <div id="video-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title">Hágalo usted mismo</h2>
            <h5 class="subtitle">Tutoriales y consejos para tus proyectos</h5>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 col-xl-3 category-sample-1" v-for="(x, vidInx) in categories" :key="'vidInx-'+vidInx">
          <router-link class="box-category" :to="'/hagalo-usted-mismo/'+x.id">
            <h5 class="text">{{x.name}}</h5>
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+x.imageUrl+')' }">
              <img src="public/images/shared/empty.png">
            </div>

            
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      categories: []
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/hagalo-usted')).then((response)=>{
        this.categories = response.data;
      });
    }
  },

  mounted(){
     this.getContent();
  }
}
</script>
